import React from 'react'
import '../styles/style.css';

// import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Carousel from 'react-bootstrap/Carousel'
import Stack from 'react-bootstrap/Stack'

import  M1 from '../visuals/M1.png';
import  M2 from '../visuals/M2.png';
import  M3 from '../visuals/M3.png';
import  M4 from '../visuals/M4.png';
import  M5 from '../visuals/M5.png';
import  M6 from '../visuals/M6.png';

function Content() {
    return (
        <div id='body'>
            <Col className='col-md-10 centerCol'>
                <Row className='subTitle'>
                    <h3>ABOUT</h3>
                </Row>
                <Row className='center'>
                    <p>DREAM VR is a tool that allows researchers and educators to design, test, and implement empirical research studies in Virtual and Extended Reality. Designed in Unity 3D, it allows for A/B testing, survey data collection, and biometrics. Researchers create experimental sequences in a web app and assign them to access codes. All system actions and user responses are logged for analysis and system enhancement. AI tools support data analysis and visual presentation of results.</p>
                    <p>DREAM VR is a research tool featuring a calibration room into which different VR experiences can be integrated to conduct research. DREAM VR significantly simplifies research on learning with XR by providing researchers with key functionality that different studies require. Built as an extension of DREAM, a tool we designed to support desktop-based and tablet-based research</p>
                    <ul>
                        <p>There are three types of users in DREAMVR.</p>
                        <li>Researcher</li>
                        <li>Proctor</li>
                        <li>Participant</li>
                    </ul>
                </Row>

                {/* <Row className='subTitle'>
                    <h3>USER SCENARIO</h3>
                </Row>
                <Row className='center'>
                    <p>A researcher would create an account and login to DREAM to curate experiments online using the DREAM Experiment Center system, where the researchers can create sequences of instruments that include tasks and/or surveys, add custom settings available for each instrument such as allowing pause or skip features, timeout, start points, etc. Researchers will use DREAM to distribute and push access codes for proctors.</p>
                    <p>A Proctor will use an Android tablet and log in using their Proctor ID. The proctor can then use access codes provided by the researcher to download an experiment into the table. The proctor will have a dashboard where they can manage their experiments, access codes, participant rosters, manage their data to update participant response data or to refresh their experiment downloads. The dashboard will also provide a view where they can monitor the progress of the participants and the number of participants that have completed the experiment of interest. In addition, the app will support the use of a keyboard for researchers to be able to pause and skip a task using a keyboard shortcut key combination, and write in notes for tasks that have been paused or skipped.</p> 
                </Row> */}

                <Row className='subTitle'>
                    <h3>LIST OF APPLICATIONS</h3>
                </Row>
                <Row id='listOfNames'>
                    <ul>
                        <li>User management with multiple roles</li>
                        <li>Single- and multi-session (longitudinal) research</li>
                        <li>Drag-and drop sequencing of study elements, from consent to pretests, treatment conditions, and posttests</li>
                        <li>Surveys measuring emotions and presence optimized for use in VR</li>
                        <li>Logging of all user actions and system events</li>
                        <li>Collection of biometric data with E4 wristbands and Biopac MP150/160 systems</li>
                        <li>All data are de-identified to protect participants’ identities and assure confidentiality</li>
                    </ul>
                </Row>
                {/*<Row className='subTitle'>
                    <h3>SCREENSHOTS</h3>
                </Row>
                 <Row id='carousel'>
                    <Carousel data-bs-theme="dark">
                        <Carousel.Item>
                            <Stack direction="horizontal" className="h-100 justify-content-center align-items-center" gap={2}>
                                <img className="d-block w-50"src={M1} alt="add page"/>
                                <img className="d-block w-50" src={M2} alt="login page"/>
                            </Stack>
                        </Carousel.Item>
                        <Carousel.Item>
                            <Stack direction="horizontal" className="h-100 justify-content-center align-items-center" gap={2}>
                            <img className="d-block w-50" src={M3} alt="Navbar"/>
                                <img className="d-block w-50"src={M4} alt="info page"/>
                            </Stack>
                        </Carousel.Item>
                        <Carousel.Item>
                            <Stack direction="horizontal" className="h-100 justify-content-center align-items-center" gap={2}>
                                <img className="d-block w-50" src={M5} alt="experiments selection page"/>
                                <img className="d-block w-50" src={M6} alt="experiment preview"/>
                            </Stack>
                        </Carousel.Item>
                    </Carousel>
                </Row> */}
            </Col>

        </div>
    
    
      )
}

export default Content